/**
 * React Query 클라이언트 설정
 */

import { QueryClient } from "@tanstack/react-query";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 24시간 동안 데이터를 "fresh"로 간주 (재요청 안 함)
        staleTime: 24 * 60 * 60 * 1000,
        // 7일 동안 캐시 유지
        gcTime: 7 * 24 * 60 * 60 * 1000,
        // 재시도 횟수
        retry: 2,
        // 윈도우 포커스 시 재요청 비활성화
        refetchOnWindowFocus: false,
        // 마운트 시 재요청 비활성화 (stale 상태여도)
        refetchOnMount: false,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (typeof window === "undefined") {
    // 서버: 항상 새 클라이언트 생성
    return makeQueryClient();
  } else {
    // 브라우저: 싱글톤 사용
    if (!browserQueryClient) {
      browserQueryClient = makeQueryClient();
    }
    return browserQueryClient;
  }
}
